<template>
	<template v-if="isMultiblock == 'false'">
		<section class="container-gallery" :id="[index]">
			<div class="container">
				<h2>{{ pictureData.config.title }}</h2>
				<GalleryItem :pictureItemData="pictureData"/>
			</div>
		</section>
	</template>
	<template v-else>
		<GalleryItem :pictureItemData="pictureData"/>
	</template>

</template>


<script>
import GalleryItem from "./GalleryItem.vue";


export default {
	components: {
		GalleryItem
	},

	props: {
		pictureData: {
			type: Object
		},
		index: {
			type: Number
		},

		perPage: {
			type: Number
		},

		isMultiblock: {
			type: String
		}
	},

};
</script>

<style lang="scss" scoped>
// @import "@/assets/scss/design-two/galleryComponent.scss";
</style>